import { Directive } from '@angular/core';

@Directive({
  selector: '[xpo-global-filter-bar]',
  host: { class: 'xpo-GlobalFilterBar' },
})
export class XpoGlobalFilterBar {}
